/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OnlinePaymentMethod {
    CARD = 'card',
    SEPA = 'sepa',
    PAYPAL = 'paypal',
    KLARNA = 'klarna',
    BANK_TRANSFER = 'bank_transfer',
    APPLE_PAY = 'apple_pay',
    GOOGLE_PAY = 'google_pay',
}
